export default theme => ({
  latestNewsButton: {
    cursor: 'pointer',
    background: '#e4eaee',
    minWidth: 70,
    maxWidth: 100,
    height: 74,
    color: '#950501',
    display: 'block',
    fontSize: 14,
    fontWeight: 'bold',
    lineHeight: 1.1,
    textAlign: 'center',
    borderRight: '1px solid #e0e0e0'
  },
  arrowDown: {
    width: 0,
    height: 0,
    display: 'block',
    borderLeft: '5px solid transparent',
    borderRight: '5px solid transparent',
    borderTop: '5px solid #950501',
    margin: '0 auto',
    marginTop: 5,
    fontSize: 22,
    paddingTop: 2
  }
});